import styled from 'styled-components';

export const NameDiv = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.info.main};
  margin-left: 5px;
  margin-right: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const DropdownOption = styled.div`
  padding: 0 10px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 40px;
  white-space: nowrap;
  width: 100%;
  box-sizing: border-box;
  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;

export const SwitchAccountsDiv = styled.div`
  text-align: center;
  font-size: 14px;
  background-color: ${({ theme }) => theme.palette.background.default};
  color: ${({ theme }) => theme.palette.text.primary};
  padding: 3%;
  box-sizing: border-box;
`;

export const Header = styled.div<{ open?: boolean }>`
  display: inline-flex;
  min-height: 100%;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
  ${(props) =>
    props.open
      ? `background-color: ${props.theme.palette.background.default};`
      : ''}
  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;

export const Dropdown = styled.div`
  height: 100%;
  margin-right: 10px;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: pointer;
`;

export const DropdownDiv = styled.div`
  box-shadow: 0 0 5px 0 ${({ theme }) => theme.palette.grey['900']}24;
  font-size: 14px;
  width: 100%;
`;

export const OverflowHidden = styled.div`
  overflow: hidden;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;

  max-height: 0;

  &.open {
    max-height: 100%;
  }

  transition: max-height 0.1s linear;
`;

export const TextCenter = styled.div`
  width: 100%;
  text-align: center;
`;
